import "regenerator-runtime/runtime";
import _asyncToGenerator from "I:\\lcy\\\u5DE5\u4F5C\\\u7F51\u7AD9\\\u672A\u5B8C\u6210\\\u4E09\u624D\u91C7\u7F16\\\u793A\u8303\u7AD9\u70B9new\\aliyun\\samsonwebfinal\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "Page404",
  data: function data() {
    return {
      ArticleID: "",
      path: "",
      paths: "",
      isShow: false,
      loading: true,
      timer: null
    };
  },
  computed: {
    message: function message() {
      return "找不到网页！";
    }
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var _this = this;

      var ArticleNum, data, res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              ArticleNum = this.$route.query.id;
              data = {
                ArticleNum: ArticleNum
              };
              _context.next = 4;
              return this.$store.dispatch("_GetArticleIDByNum", data);

            case 4:
              res = _context.sent;

              if (res.data.IsSuccess) {
                this.loading = false;
                this.isShow = false;
                this.ArticleID = res.data.Data.ArticleID;
                this.timer = (function () {
                  window.location.href = _this.Url + "#/digest?ArticleID=" + _this.ArticleID;
                }, 100);
              } else {
                this.loading = false;
                this.isShow = true;
              }

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  beforeDestroy: function beforeDestroy() {
    this.loading = false;
    clearInterval(this.timer);
    this.timer = null;
  }
};